var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcwCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50591 12.5C8.38901 12.2 8.22201 11.8 8.02161 11.3C7.82121 10.8 7.554 10.1666 7.22 9.43329C7.053 9.06663 6.8693 8.64996 6.6689 8.21663L6.552 7.96663H3.69629L8.37231 18.3333L16.3048 1.66663L8.50591 12.5Z",
    fill: "url(#paint0_linear_3355_22051)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3355_22051",
    x1: 10.0088,
    y1: 18.3057,
    x2: 10.0088,
    y2: 1.66663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65933F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    stopColor: "#BAD532"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcwCheckIcon);
export default __webpack_public_path__ + "static/media/icw-check-icon.76ffdb212dd92a978330ce4daffa80d6.svg";
export { ForwardRef as ReactComponent };